import { Injectable } from '@angular/core';
import { FileData } from '../blob-storage/models/FileData';
import { Observable, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ContainerJobPodData } from '../Container/model/ContainerJobPodData';

@Injectable({
  providedIn: 'root'
})
export class ProofOfDeliveryPdfService {

  constructor(private http$: HttpClient) { }

  printOrderPodPdf(orderId: number): Observable<FileData> {
    return this.http$.get<FileData>(`api/pdf/order/${orderId}/pod`);
  }

  printOrderConsignmentPdf(orderId: number): Observable<FileData> {
    return this.http$.get<FileData>(`api/pdf/order/${orderId}/consignment`);
  }

  printOrderPalletLabel(orderId: number, numberOfLabels: number): Observable<FileData> {
    return this.http$.get<FileData>(`api/pdf/order/${orderId}/palletlabel/${numberOfLabels}`);
  }

  getJobPodData(jobId: number): Observable<any> {
    return this.http$.get<any>(`api/pdf/job/${jobId}/pod`);
  }

  printJobPodPdf(jobId: number): Observable<FileData> {
    return this.http$.get<FileData>(`api/pdf/job/${jobId}/pod/pdf`);
  }

  printJobSheetPdf(jobId: number): Observable<FileData> {
    return this.http$.get<FileData>(`api/pdf/job/${jobId}/sheet/pdf`);
  }

  sendJobPodEmail(jobId: number, email: string[]) {
    const model = {
      recipients: email,
    }

    return this.http$.post<void>(`api/pdf/job/${jobId}/pod/send`, model).pipe(take(1));
  }

  sendOrderPodEmail(orderId: number, email: string[]){
    const model = {
        recipients: email,
    }
    
    return this.http$.post<void>(`api/pdf/order/${orderId}/pod/email`, model).pipe(take(1));
  }

  getContainerJobPodData(containerJobItemId: number): Observable<ContainerJobPodData> {
    return this.http$.get<ContainerJobPodData>(`api/pdf/containerjob/${containerJobItemId}/pod`);
  }

  printContainerJobPodPdf(containerJobItemId: number): Observable<FileData> {
    return this.http$.get<FileData>(`api/pdf/containerjob/${containerJobItemId}/pod/pdf`);
  }

  sendContainerJobPodEmail(containerJobItemId: number, email: string[]){
    const model = {
        recipients: email,
    }
    
    return this.http$.post<void>(`api/pdf/containerjob/${containerJobItemId}/pod/send`, model).pipe(take(1));
  }
}
